import type { Category } from '../data/types'

interface Props {
  categories: Category[]
  selectedId: string | null
  onSelect: (categoryId: string | null) => void
}

/**
 * The paint palette for Today and Week. Pick a category, then drag across empty
 * time to lay a block down — no dialog in between.
 */
export function CategoryRail({ categories, selectedId, onSelect }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="pr-1 text-[11px] font-medium tracking-wide text-faint uppercase">Paint</span>
      {categories.map((category) => {
        const selected = category.id === selectedId
        return (
          <button
            key={category.id}
            type="button"
            onClick={() => onSelect(selected ? null : category.id)}
            aria-pressed={selected}
            style={{ '--c': category.color } as React.CSSProperties}
            className={`rounded-md border px-2 py-1 text-[13px] leading-none font-medium transition-[background-color,border-color] duration-150 ease-[var(--ease-out-quick)] ${
              selected
                ? 'border-[var(--c)] bg-[var(--c)] text-[#0a0b0c]'
                : 'border-[color-mix(in_oklab,var(--c)_34%,transparent)] bg-[color-mix(in_oklab,var(--c)_12%,var(--tg-surface))] text-[color-mix(in_oklab,var(--c)_72%,var(--tg-text))] hover:bg-[color-mix(in_oklab,var(--c)_20%,var(--tg-surface))]'
            }`}
          >
            {category.shortLabel}
          </button>
        )
      })}
    </div>
  )
}
